import { multimediaEpaycoUrl } from "../../utils/multimedia";
import { REACT_APP_API_URL, REACT_APP_SERVER, REACT_APP_SERVER_RESPONSE, REACT_APP_PROJECT_ID_RECAUDO } from "../../config/env";
/* eslint-disable eqeqeq */
import React, { Component, Fragment } from "react";
import { Flex, Mycard, Elastic, colors, MyCampo, Transition } from "../ui";
import { Btn } from "./../UI-Components/Btn";
import { withRouter } from "react-router";
import ReactTooltip from "react-tooltip";
import { ExternalScript as Script } from "../../utils/loadExternalScript";
import MyRadio from "../Helpers/Radios";
import { Tooltip } from "react-tippy";
/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import styled from "@emotion/styled";
import {
  b64toBlob,
  parseJwt,
  serviceApiResponse,
  serviceApiGet,
  getGeoIpUrl,
} from "../ServiciosMaestros/request";
import { api } from "../ServiciosMaestros/apis";
import { getInvoiceId } from "../ServiciosMaestros/getInvoice";
import { reportPagoError } from "../ServiciosMaestros/handleIntegrationError";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "../../Components/ServiciosMaestros/componentGeneral";
import {CHECKOUT_VERSION, checkoutScriptVersion, checkoutType, checkoutVersion } from "../../utils/checkout";
import ColumnGroup from "antd/es/table/ColumnGroup";

toast.configure({
  autoClose: 5000,
  draggable: true,
});

const Ct = css`
  color: ${colors.btn};
`;

export const Line = styled.div`
  border-bottom: 1px ${(props) => (props.dotted ? "dotted " : "solid ")}
    ${colors.title};
  width: 100%;
`;

export const FooterFactura = (props) => {
  return (
    <Flex className={"p-3 "}>
      <p className={"mb-0 cg"}>
        Si tiene alguna duda puede escribir a{" "}
        <span css={Ct}>{props.info.correo_empresa}</span>, o llamar al{" "}
        <span css={Ct}>{`(${
          props.info.tipoTelefonoValue === "fijo"
            ? props.info.valueIndicativo
            : props.info.indicativoPais
        }) ${props.info.tel_empresa}`}</span>
      </p>
      {/*<span css={Ct}>(054) 234 56 78</span></p>*/}
    </Flex>
  );
};

let ruta = {};

class FacturaPagar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingDownload: false,
      infoFactura: [],
      infoCabecera: {},
      infoEmpresa: {},
      total: 0,
      isSuscrito: null,
      accionSuscripciones: "",
      moneda: "COP",
      iva: 0,
      facturasCheckout: "",
      opcionesRecaudo: null,
      otroValor: 0,
      otroValorChecked: false,
      abonos: [],
      opcionPago: [],
      facturas: [],
      fechasValidacion: [],
      loadingSuscripciones: false,
      cambioValor: false,
      pagoMinimo: 0,
      pagoMinimoMoneda: "$ 0",
      projectId: 0,
      modal: {
        typo: "warning",
        open: false,
        message: "true",
        action: () => null,
      },
      loadingPayment: false,
      valorInvalido: false,
    };
    this.FormatoCampo = this.FormatoCampo.bind(this);
    this.validateFactura = this.validateFactura.bind(this);
    this.modalFacturasConPago = this.modalFacturasConPago.bind(this);
    this.homePath = this.homePath.bind(this);
    this.borrarFacturasConPago = this.borrarFacturasConPago.bind(this);
  }
  componentDidMount() {
    ruta = JSON.parse(sessionStorage.getItem("rutas"));
    let projectId = JSON.parse(sessionStorage.getItem("informacion"));
    projectId = projectId ? projectId.key : 0;
    this.setState({
      opcionesRecaudo:
        JSON.parse(sessionStorage.getItem("opcionesRecaudo")) || null,
      projectId,
    });
    if (sessionStorage.getItem("noRederict")) {
      sessionStorage.removeItem("noRederict");
    } else if (typeof this.props.location.isSuscrito === "undefined")
      this.props.history.push(ruta.home);

    const isSuscrito = this.props.location.isSuscrito;
    const accionSuscripciones = sessionStorage.getItem("accionSuscripciones");
    if (isSuscrito) {
      this.setState({ isSuscrito: isSuscrito, accionSuscripciones });
    }
    if (accionSuscripciones) {
      this.setState({ isSuscrito: isSuscrito, accionSuscripciones });
    }

    let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
    let facturas = JSON.parse(sessionStorage.getItem("facturas"));
    let opcionesRecaudo = JSON.parse(sessionStorage.getItem("opcionesRecaudo"));
    let key = sessionStorage.getItem("facturaPagar")
      ? JSON.parse(sessionStorage.getItem("facturaPagar"))
      : [0];
    let key2 = [];
    if (key.length > 1) {
      key.map((it, k) => {
        if (k <= facturas.length) {
          key2.push(it);
        }
        return "";
      });
      key = key2;
    }
    if (typeof key === "number") {
      key = [key];
    }
    let param =
      Object.keys(opcionesRecaudo).length > 0
        ? JSON.parse(sessionStorage.getItem("param"))
        : {};
    let configuracion = JSON.parse(sessionStorage.getItem("configuracion"));
    let facturasCopy = [];
    let abonos = [];
    let opcionPago = [];
    if (facturas && facturas.length > 0) {
      let total = 0;
      let moneda = configuracion.info.moneda;
      let iva = 0;
      let iva1 = 0;
      let fact = [];
      let entidadValor = "";
      let entidadIva = "";
      let posicionIva = [];
      let idCheckout = "";
      let valorCheckout = "";
      let aux = false;
      key.forEach((ks) => {
        if (facturas[ks] !== undefined) {
          fact.push(facturas[ks]);
          facturasCopy.push(facturas[ks]);
        }
      });
      let check = [];
      let checksOtroValor = [];
      let checksValor1 = [];
      let checksValor2 = [];
      let checksValor3 = [];
      let valuesOtroValor = [];
      let validarFecha = [];
      let posicionInfo = 0;
      let session = false;
      let visibleIva = false;
      if (sessionStorage.getItem("check")) {
        check = JSON.parse(sessionStorage.getItem("check"));
        checksOtroValor = JSON.parse(sessionStorage.getItem("checksOtroValor"));
        checksValor1 = JSON.parse(sessionStorage.getItem("checksValor1"));
        checksValor2 = JSON.parse(sessionStorage.getItem("checksValor2"));
        checksValor3 = JSON.parse(sessionStorage.getItem("checksValor3"));
        valuesOtroValor = JSON.parse(sessionStorage.getItem("valuesOtroValor"));
        check.forEach((c) => {
          if (c) session = true;
        });
        checksOtroValor.forEach((c) => {
          if (c) session = true;
        });

        checksValor1.forEach((c) => {
          if (c) session = true;
        });

        checksValor2.forEach((c) => {
          if (c) session = true;
        });

        checksValor3.forEach((c) => {
          if (c) session = true;
        });

        if (checksOtroValor.length > facturas.length) {
          let checksOtroValorN = [];
          let checksValor1N = [];
          let checksValor2N = [];
          let checksValor3N = [];
          let valuesOtroValorN = [];
          facturas.map((it, k) => {
            checksOtroValorN.push(checksOtroValor[k]);
            checksValor1N.push(checksValor1[k]);
            checksValor2N.push(checksValor2[k]);
            checksValor3N.push(checksValor3[k]);
            valuesOtroValorN.push(valuesOtroValor[k]);
          });
          checksOtroValor = checksOtroValorN;
          checksValor1 = checksValor1N;
          checksValor2 = checksValor2N;
          checksValor3 = checksValor3N;
          valuesOtroValor = valuesOtroValorN;
        }
      }
      let info = JSON.parse(sessionStorage.getItem("informacion"));
      let infoCabecera = {};
      let infoFactura = [];

      let valorCalculado = false;
      let valor = 0;
      let checkDuplicateIva = true;
      configCampos.map((conf, kconf) => {
        let keysOfDirefentData = [];
        if (fact.length > 1) {
          valor = 0;
          Object.keys(fact[0]).forEach((f, fk) => {
            if (conf === f) {
              fact.forEach((fac, i) => {
                if (i !== 0) {
                  if (
                    keysOfDirefentData.length === 0 ||
                    !keysOfDirefentData.includes(f)
                  ) {
                    if (fact[0][f] !== fac[f]) {
                      keysOfDirefentData.push(f);
                    }
                  }
                }
              });
            }
          });

          let data = {};
          valorCalculado = false;
          Object.keys(fact[0]).forEach((k) => {
            if (
              k === conf.entidad &&
              conf.visible &&
              !keysOfDirefentData.includes(k)
            ) {
              data["titulo"] = conf.titulo_campo;
              data["ayuda"] = conf.texto_ayuda;
              if (
                k === conf.entidad &&
                (conf.tipo_campo.search("valor") !== -1 ||
                  conf.tipo_campo.search("total") !== -1 ||
                  conf.tipo_campo.search("segundoTotal") !== -1 ||
                  conf.tipo_campo.search("tercerTotal") !== -1)
              ) {
                valorCalculado = true;
                entidadValor = k;
                key.forEach((v, knn) => {
                  if (fact[knn]) {
                    let splitIdCheckout = idCheckout.split(":");
                    let contiene = false;
                    splitIdCheckout.forEach((sp) => {
                      if (sp == fact[knn]["id"]) {
                        contiene = true;
                      }
                    });
                    if (!contiene) {
                      idCheckout += `${String(fact[knn]["id"])}${
                        knn === key.length - 1 ? "" : ":"
                      }`;
                    }
                  }

                  if (session) {
                    if (checksValor1[v]) {
                      if (k === "total") {
                        if (knn === 0) {
                          checkDuplicateIva = iva === 0;
                        }
                        if (
                          fact[knn] &&
                          fact[knn]["iva"] &&
                          fact[knn]["iva"] !== null &&
                          checkDuplicateIva
                        ) {
                          iva += fact[knn]["iva"];
                        }
                      }
                      if (fact[knn] && fact[knn]["fechaExpiracion"])
                        validarFecha.push("fechaExpiracion");
                      opcionPago.push("total");
                      abonos.push(null);
                      if (fact[knn]) valor += parseFloat(fact[knn]["total"]);
                      if (fact[knn]) {
                        let splitIdCheckout = valorCheckout.split(":");
                        if (
                          splitIdCheckout.length < fact.length ||
                          splitIdCheckout[splitIdCheckout.length - 1] == ""
                        ) {
                          valorCheckout += `${String(fact[knn]["total"])}${
                            knn === key.length - 1 ? "" : ":"
                          }`;
                        }
                      }
                    }
                    if (checksValor2[v]) {
                      if ("segundoTotal") {
                        if (
                          fact[knn] &&
                          fact[knn]["segundoIva"] &&
                          fact[knn]["segundoIva"] !== null
                        ) {
                          iva += fact[knn]["segundoIva"];
                        }
                      }
                      if (fact[knn] && fact[knn]["segundaFechaVencimiento"])
                        validarFecha.push("segundaFechaVencimiento");
                      opcionPago.push("segundoTotal");
                      abonos.push(null);
                      if (fact[knn]) valor += parseFloat(fact[knn]["segundoTotal"]);
                      let splitIdCheckout = valorCheckout.split(":");
                      if (
                        splitIdCheckout.length < fact.length ||
                        splitIdCheckout[splitIdCheckout.length - 1] == ""
                      ) {
                        valorCheckout += `${String(fact[knn]["segundoTotal"])}${
                          knn === key.length - 1 ? "" : ":"
                        }`;
                      }
                    }
                    if (checksValor3[v]) {
                      if ("tercerTotal") {
                        if (
                          fact[knn] &&
                          fact[knn]["tercerIva"] &&
                          fact[knn]["tercerIva"] !== null
                        ) {
                          iva += fact[knn]["tercerIva"];
                        }
                      }
                      if (fact[knn] && fact[knn]["tercerFechaVencimiento"])
                        validarFecha.push("tercerFechaVencimiento");
                      opcionPago.push("tercerTotal");
                      abonos.push(null);
                      if (fact[knn]) valor += parseFloat(fact[knn]["tercerTotal"]);
                      if (fact[knn]) {
                        let splitIdCheckout = valorCheckout.split(":");
                        if (
                          splitIdCheckout.length < fact.length ||
                          splitIdCheckout[splitIdCheckout.length - 1] == ""
                        ) {
                          valorCheckout += `${String(
                            fact[knn]["tercerTotal"]
                          )}${knn === key.length - 1 ? "" : ":"}`;
                        }
                      }
                    }
                    if (checksOtroValor[v]) {
                      if (
                        k === "total" &&
                        fact[knn]["iva"] &&
                        fact[knn]["iva"] !== null
                      ) {
                        if (fact[knn])
                          iva +=
                            (fact[knn]["iva"] / fact[knn]["total"]) *
                            valuesOtroValor[key[0]];
                      } else if (
                        k === "segundoTotal" &&
                        fact[knn]["segundoIva"] &&
                        fact[knn]["segundoIva"] !== null
                      ) {
                        if (fact[knn])
                          iva +=
                            (fact[knn]["segundoIva"] /
                              fact[knn]["segundoTotal"]) *
                            valuesOtroValor[key[0]];
                      } else if (
                        k === "tercerTotal" &&
                        fact[knn]["tercerIva"] &&
                        fact[knn]["tercerIva"] !== null
                      ) {
                        if (fact[knn])
                          iva +=
                            (fact[knn]["tercerIva"] /
                              fact[knn]["tercerTotal"]) *
                            valuesOtroValor[key[0]];
                      }
                      opcionPago.push("abono");
                      abonos.push(valuesOtroValor[v]);
                      valor += parseFloat(valuesOtroValor[v]);
                      let splitIdCheckout = valorCheckout.split(":");
                      if (
                        splitIdCheckout.length < fact.length ||
                        splitIdCheckout[splitIdCheckout.length - 1] == ""
                      ) {
                        valorCheckout += `${String(valuesOtroValor[v])}${
                          knn === key.length - 1 ? "" : ":"
                        }`;
                      }
                    }
                  } else {
                    if (k === "total" && fact[knn]["fechaExpiracion"]) {
                      validarFecha.push("fechaExpiracion");
                    } else if (
                      k === "segundoTotal" &&
                      fact[knn]["segundaFechaVencimiento"]
                    ) {
                      validarFecha.push("segundaFechaVencimiento");
                    } else if (
                      k === "tercerTotal" &&
                      fact[knn]["tercerFechaVencimiento"]
                    ) {
                      validarFecha.push("tercerFechaVencimiento");
                    }
                    opcionPago.push(k);
                    abonos.push(null);
                    valor += parseFloat(fact[knn][k]);
                    let splitIdCheckout = valorCheckout.split(":");
                    if (
                      splitIdCheckout.length < fact.length ||
                      splitIdCheckout[splitIdCheckout.length - 1] == ""
                    ) {
                      valorCheckout += `${String(fact[knn][k])}${
                        knn === key.length - 1 ? "" : ":"
                      }`;
                    }
                  }
                });
                data["valor"] = `$ ${parseFloat(valor).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                })} ${fact[0]["moneda"]}`;
                total = valor;
                moneda = fact[0]["moneda"];
              } else if (
                k === conf.entidad &&
                (conf.entidad === "iva" ||
                  conf.entidad === "segundoIva" ||
                  conf.entidad === "tercerIva")
              ) {
                entidadIva = k;
                posicionInfo = infoFactura.length;
                visibleIva = true;
                key.forEach((v, kn) => {
                  if (session) {
                    if (checksValor1[v]) {
                      iva1 += fact[kn][k];
                    }
                    if (checksOtroValor[v]) {
                      if (valorCalculado) {
                        let valorDelIva =
                          (fact[kn][k] / fact[kn][entidadValor]) *
                          valuesOtroValor[v];
                        iva1 += valorDelIva;
                      } else {
                        posicionIva.push(kn);
                      }
                    }
                  } else {
                    iva1 += fact[kn][k];
                  }
                });

                data["valor"] = `$ ${parseFloat(iva1).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                })} ${fact[0]["moneda"]}`;
                iva = iva1;
              } else if (k === conf.entidad) {
                data["valor"] = fact[0][k];
              }
              if (conf.entidad === "facturaId") {
                infoCabecera = data;
              }

              infoCabecera = { titulo: param.option, valor: param.referencia };
            } else if (
              k === conf.entidad &&
              (conf.entidad === "total" ||
                conf.entidad === "iva" ||
                conf.entidad === "segundoIva" ||
                conf.entidad === "tercerIva" ||
                conf.tipo_campo.search("segundoTotal") !== -1 ||
                conf.tipo_campo.search("tercerTotal") !== -1)
            ) {
              if (
                (k === conf.entidad &&
                  (conf.tipo_campo.search("valor") !== -1 ||
                    conf.tipo_campo.search("total") !== -1 ||
                    conf.tipo_campo.search("segundoTotal") !== -1)) ||
                conf.tipo_campo.search("tercerTotal") !== -1
              ) {
                valorCalculado = true;
                entidadValor = k;
                key.forEach((v, knn) => {
                  if (fact[knn]) {
                    let splitIdCheckout = idCheckout.split(":");
                    let contiene = false;
                    splitIdCheckout.forEach((sp) => {
                      if (sp == fact[knn]["id"]) {
                        contiene = true;
                      }
                    });
                    if (!contiene) {
                      idCheckout += `${String(fact[knn]["id"])}${
                        knn === key.length - 1 ? "" : ":"
                      }`;
                    }
                  }

                  if (session) {
                    if (checksValor1[v]) {
                      if (k === "total") {
                        if (
                          fact[knn] &&
                          fact[knn]["iva"] &&
                          fact[knn]["iva"] !== null
                        ) {
                          iva += fact[knn]["iva"];
                        }
                      }
                      if (
                        fact[knn] &&
                        fact[knn]["fechaExpiracion"] &&
                        conf.visible
                      )
                        validarFecha.push("fechaExpiracion");
                      opcionPago.push("total");
                      abonos.push(null);
                      if (fact[knn]) valor += parseFloat(fact[knn]["total"]);
                      if (fact[knn]) {
                        let splitIdCheckout = valorCheckout.split(":");
                        if (
                          splitIdCheckout.length < fact.length ||
                          splitIdCheckout[splitIdCheckout.length - 1] == ""
                        ) {
                          valorCheckout += `${String(fact[knn]["total"])}${
                            knn === key.length - 1 ? "" : ":"
                          }`;
                        }
                      }
                    }
                    if (checksValor2[v]) {
                      if ("segundoTotal") {
                        if (
                          fact[knn]["segundoIva"] &&
                          fact[knn]["segundoIva"] !== null
                        ) {
                          iva += fact[knn]["segundoIva"];
                        }
                      }
                      if (fact[knn]["segundaFechaVencimiento"] && conf.visible)
                        validarFecha.push("segundaFechaVencimiento");
                      opcionPago.push("segundoTotal");
                      abonos.push(null);
                      valor += parseFloat(fact[knn]["segundoTotal"]);
                      let splitIdCheckout = valorCheckout.split(":");
                      if (
                        splitIdCheckout.length < fact.length ||
                        splitIdCheckout[splitIdCheckout.length - 1] == ""
                      ) {
                        valorCheckout += `${String(fact[knn]["segundoTotal"])}${
                          knn === key.length - 1 ? "" : ":"
                        }`;
                      }
                    }
                    if (checksValor3[v]) {
                      if ("tercerTotal") {
                        if (
                          fact[knn] &&
                          fact[knn]["tercerIva"] &&
                          fact[knn]["tercerIva"] !== null
                        ) {
                          iva += fact[knn]["tercerIva"];
                        }
                      }
                      if (
                        fact[knn] &&
                        fact[knn]["tercerFechaVencimiento"] &&
                        conf.visible
                      )
                        validarFecha.push("tercerFechaVencimiento");
                      opcionPago.push("tercerTotal");
                      abonos.push(null);
                      if (fact[knn]) valor += parseFloat(fact[knn]["tercerTotal"]);
                      if (fact[knn]) {
                        let splitIdCheckout = valorCheckout.split(":");
                        if (
                          splitIdCheckout.length < fact.length ||
                          splitIdCheckout[splitIdCheckout.length - 1] == ""
                        ) {
                          valorCheckout += `${String(
                            fact[knn]["tercerTotal"]
                          )}${knn === key.length - 1 ? "" : ":"}`;
                        }
                      }
                    }
                    if (checksOtroValor[v]) {
                      if (
                        k === "total" &&
                        fact[knn]["iva"] &&
                        fact[knn]["iva"] !== null
                      ) {
                        iva +=
                          (fact[knn]["iva"] / fact[knn]["total"]) *
                          valuesOtroValor[key[0]];
                      } else if (
                        k === "segundoTotal" &&
                        fact[knn]["segundoIva"] &&
                        fact[knn]["segundoIva"] !== null
                      ) {
                        iva +=
                          (fact[knn]["segundoIva"] /
                            fact[knn]["segundoTotal"]) *
                          valuesOtroValor[key[0]];
                      } else if (
                        k === "tercerTotal" &&
                        fact[knn]["tercerIva"] &&
                        fact[knn]["tercerIva"] !== null
                      ) {
                        iva +=
                          (fact[knn]["tercerIva"] / fact[knn]["tercerTotal"]) *
                          valuesOtroValor[key[0]];
                      }
                      opcionPago.push("abono");
                      abonos.push(valuesOtroValor[v]);
                      valor += parseFloat(valuesOtroValor[v]);
                      let splitIdCheckout = valorCheckout.split(":");
                      if (
                        splitIdCheckout.length < fact.length ||
                        splitIdCheckout[splitIdCheckout.length - 1] == ""
                      ) {
                        valorCheckout += `${String(valuesOtroValor[v])}${
                          knn === key.length - 1 ? "" : ":"
                        }`;
                      }
                    }
                  } else {
                    if (k === "total") {
                      if (fact[knn]["iva"] && fact[knn]["iva"] !== null) {
                        iva = fact[knn]["iva"];
                      }
                    } else if ("segundoTotal") {
                      if (
                        fact[knn]["segundoIva"] &&
                        fact[knn]["segundoIva"] !== null
                      ) {
                        iva = fact[knn]["segundoIva"];
                      }
                    } else if ("tercerTotal") {
                      if (
                        fact[knn]["tercerIva"] &&
                        fact[knn]["tercerIva"] !== null
                      ) {
                        iva = fact[knn]["tercerIva"];
                      }
                    }
                    opcionPago.push(k);
                    abonos.push(null);
                    valor += parseFloat(fact[knn][k]);
                    let splitIdCheckout = valorCheckout.split(":");
                    if (
                      splitIdCheckout.length < fact.length ||
                      splitIdCheckout[splitIdCheckout.length - 1] == ""
                    ) {
                      valorCheckout += `${String(fact[knn][k])}${
                        knn === key.length - 1 ? "" : ":"
                      }`;
                    }
                  }
                });
                total = valor;
                moneda = fact[0]["moneda"];
              }
              if (conf.entidad === "facturaId") {
                infoCabecera = data;
              }

              if (
                Object.keys(opcionesRecaudo).length > 0 &&
                opcionesRecaudo.generarNumeroFactura.activo
              ) {
                infoCabecera = {
                  titulo: param.option,
                  valor: param.referencia,
                };
              }
            }
          });

          if (Object.keys(data).length > 0) {
            infoFactura.push(data);
          }

          if (kconf === 0) {
            infoFactura.unshift({
              titulo: "Número de facturas seleccionadas",
              ayuda: "",
              valor: key.length,
            });
          }

          if (opcionesRecaudo && opcionesRecaudo.generarNumeroFactura.activo) {
            let param = JSON.parse(sessionStorage.getItem("param"));
            infoCabecera["titulo"] = param.option;
            infoCabecera["valor"] = param.referencia;
          }
        } else {
          fact.forEach((fac, i) => {
            let data = {};
            Object.keys(fac).filter((k) => {
              if (k === conf.entidad && conf.visible) {
                data["titulo"] = conf.titulo_campo;
                data["ayuda"] = conf.texto_ayuda;
                data["entidad"] = conf.entidad;
                data["checked"] = false;
                data["tipo_campo_2"] = conf.tipo_campo_2;
                data["moneda"] = fact[0]["moneda"];
                if (
                  conf.entidad === "total" ||
                  conf.entidad === "segundoTotal" ||
                  conf.entidad === "tercerTotal"
                ) {
                  entidadValor = k;
                  valorCalculado = true;
                  if (idCheckout === "") {
                    idCheckout += `${String(fact[i]["id"])}${
                      i === fact.length - 1 ? "" : ":"
                    }`;
                  }
                  data["valor"] = `$ ${parseFloat(fac[k]).toLocaleString(
                    "en-US",
                    { minimumFractionDigits: 2 }
                  )} ${fac["moneda"]}`;
                  data["valorReal"] = fac[k];
                  if (session) {
                    if (checksValor1[key[0]] && k === "total") {
                      if (fac["iva"] && fac["iva"] !== null) {
                        iva = fac["iva"];
                      }
                      if (fac["fechaExpiracion"])
                        validarFecha.push("fechaExpiracion");
                      abonos.push(null);
                      opcionPago.push(k);
                      total += fac["total"];
                      let splitIdCheckout = valorCheckout.split(":");
                      if (
                        splitIdCheckout.length < fact.length ||
                        splitIdCheckout[splitIdCheckout.length - 1] == ""
                      ) {
                        valorCheckout += `${String(fac["total"])}${
                          i === fact.length - 1 ? "" : ":"
                        }`;
                      }

                      data["valor"] = `$ ${parseFloat(
                        fac["total"]
                      ).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                      })} ${fac["moneda"]}`;
                    }

                    if (checksValor2[key[0]] && k === "segundoTotal") {
                      if (fac["segundoIva"] && fac["segundoIva"] !== null) {
                        iva = fac["segundoIva"];
                      }
                      if (fac["segundaFechaVencimiento"])
                        validarFecha.push("segundaFechaVencimiento");
                      abonos.push(null);
                      opcionPago.push(k);
                      total += fac["segundoTotal"];
                      let splitIdCheckout = valorCheckout.split(":");
                      if (
                        splitIdCheckout.length < fact.length ||
                        splitIdCheckout[splitIdCheckout.length - 1] == ""
                      ) {
                        valorCheckout += `${String(fac["segundoTotal"])}${
                          i === fact.length - 1 ? "" : ":"
                        }`;
                      }

                      data["valor"] = `$ ${parseFloat(
                        fac["segundoTotal"]
                      ).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                      })} ${fac["moneda"]}`;
                    }

                    if (checksValor3[key[0]] && k === "tercerTotal") {
                      if (fac["tercerIva"] && fac["tercerIva"] !== null) {
                        iva = fac["tercerIva"];
                      }
                      if (fac["tercerFechaVencimiento"])
                        validarFecha.push("tercerFechaVencimiento");
                      abonos.push(null);
                      opcionPago.push(k);
                      total += fac["tercerTotal"];
                      let splitIdCheckout = valorCheckout.split(":");
                      if (
                        splitIdCheckout.length < fact.length ||
                        splitIdCheckout[splitIdCheckout.length - 1] == ""
                      ) {
                        valorCheckout += `${String(fac["tercerTotal"])}${
                          i === fact.length - 1 ? "" : ":"
                        }`;
                      }

                      data["valor"] = `$ ${parseFloat(
                        fac["tercerTotal"]
                      ).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                      })} ${fac["moneda"]}`;
                    }

                    if (checksOtroValor[key[0]] && !aux) {
                      if (
                        k === "total" &&
                        fact[i]["iva"] &&
                        fact[i]["iva"] !== null
                      ) {
                        iva =
                          (fact[i]["iva"] / fact[i]["total"]) *
                          valuesOtroValor[key[0]];
                      } else if (
                        k === "segundoTotal" &&
                        fact[i]["segundoIva"] &&
                        fact[i]["segundoIva"] !== null
                      ) {
                        iva =
                          (fact[i]["segundoIva"] / fact[i]["segundoTotal"]) *
                          valuesOtroValor[key[0]];
                      } else if (
                        k === "tercerTotal" &&
                        fact[i]["tercerIva"] &&
                        fact[i]["tercerIva"] !== null
                      ) {
                        iva =
                          (fact[i]["tercerIva"] / fact[i]["tercerTotal"]) *
                          valuesOtroValor[key[0]];
                      }

                      if (k === "total" && fact[i]["fechaExpiracion"]) {
                        validarFecha.push("fechaExpiracion");
                      } else if (
                        k === "segundoTotal" &&
                        fact[i]["segundaFechaVencimiento"]
                      ) {
                        validarFecha.push("segundaFechaVencimiento");
                      } else if (
                        k === "tercerTotal" &&
                        fact[i]["tercerFechaVencimiento"]
                      ) {
                        validarFecha.push("tercerFechaVencimiento");
                      }

                      abonos.push(valuesOtroValor[key[0]]);
                      opcionPago.push("abono");
                      aux = true;
                      total += valuesOtroValor[key[0]];
                      let splitIdCheckout = valorCheckout.split(":");
                      if (
                        splitIdCheckout.length < fact.length ||
                        splitIdCheckout[splitIdCheckout.length - 1] == ""
                      ) {
                        valorCheckout += `${String(valuesOtroValor[key[0]])}${
                          i === fact.length - 1 ? "" : ":"
                        }`;
                      }
                    }
                  } else {
                    if (k === "total") {
                      if (fac["iva"] && fac["iva"] !== null) {
                        iva = fac["iva"];
                      }
                    } else if ("segundoTotal") {
                      if (fac["segundoIva"] && fac["segundoIva"] !== null) {
                        iva = fac["segundoIva"];
                      }
                    } else if ("tercerTotal") {
                      if (fac["tercerIva"] && fac["tercerIva"] !== null) {
                        iva = fac["tercerIva"];
                      }
                    }

                    if (k === "total" && fact[i]["fechaExpiracion"]) {
                      validarFecha.push("fechaExpiracion");
                    } else if (
                      k === "segundoTotal" &&
                      fact[i]["segundaFechaVencimiento"]
                    ) {
                      validarFecha.push("segundaFechaVencimiento");
                    } else if (
                      k === "tercerTotal" &&
                      fact[i]["tercerFechaVencimiento"]
                    ) {
                      validarFecha.push("tercerFechaVencimiento");
                    }

                    abonos.push(null);
                    opcionPago.push(k);
                    total += fac[k];
                    let splitIdCheckout = valorCheckout.split(":");
                    if (
                      splitIdCheckout.length < fact.length ||
                      splitIdCheckout[splitIdCheckout.length - 1] == ""
                    ) {
                      valorCheckout += `${String(fac[k])}${
                        i === fact.length - 1 ? "" : ":"
                      }`;
                    }

                    data["valor"] = `$ ${parseFloat(fac[k]).toLocaleString(
                      "en-US",
                      { minimumFractionDigits: 2 }
                    )} ${fac["moneda"]}`;
                  }
                  moneda = fac["moneda"];
                } else if (
                  conf.entidad === "iva" ||
                  conf.entidad === "segundoIva" ||
                  conf.entidad === "tercerIva"
                ) {
                  visibleIva = true;
                  data["valor"] = `$ ${parseFloat(fac[k]).toLocaleString(
                    "en-US",
                    { minimumFractionDigits: 2 }
                  )} ${fac["moneda"]}`;
                } else {
                  data["valor"] = fac[k];
                }

                if (conf.entidad === "facturaId") {
                  infoCabecera = data;
                }

                if (
                  Object.keys(opcionesRecaudo).length > 0 &&
                  opcionesRecaudo.generarNumeroFactura.activo
                ) {
                  infoCabecera = {
                    titulo: param.option,
                    valor: param.referencia,
                  };
                }
              } else if (k === conf.entidad) {
                visibleIva = false;
                if (k === "total" && conf.visible) {
                  if (fac["fechaExpiracion"])
                    validarFecha.push("fechaExpiracion");
                } else if (k === "segundoTotal" && conf.visible) {
                  validarFecha.push("segundaFechaVencimiento" && conf.visible);
                } else if (k === "tercerTotal" && conf.visible) {
                  validarFecha.push("tercerFechaVencimiento");
                }
              }
              return "";
            });
            if (Object.keys(data).length > 0) {
              infoFactura.push(data);
            }
          });
        }
      });

      if (entidadIva !== "" && entidadValor !== "") {
        posicionIva.forEach((p) => {
          let valorDelIva =
            (fact[p][entidadIva] / fact[p][entidadValor]) *
            valuesOtroValor[key[p]];
          iva += valorDelIva;
        });
        if (visibleIva) {
          infoFactura[posicionInfo]["valor"] = `$ ${parseFloat(
            iva
          ).toLocaleString("en-US", { minimumFractionDigits: 2 })} ${
            fact[0]["moneda"]
          }`;
        }
      }

      if (fact.length > 1) {
        let key = [];
        infoFactura.forEach((ifo, k) => {
          configCampos.forEach((f, k2) => {
            if (
              f.titulo_campo === ifo.titulo &&
              (f.entidad === "total" ||
                f.entidad === "segundoTotal" ||
                f.entidad === "tercerTotal")
            ) {
              key.push(k);
            }
          });
        });

        let auxDelete = 0;
        key.forEach((k) => {
          infoFactura.splice(k - auxDelete, 1);
          auxDelete++;
        });

        infoFactura.push({
          titulo: "Total a pagar",
          ayuda: "",
          valor: `$ ${parseFloat(total).toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })} ${fact[0]["moneda"]}`,
        });
      }

      if (fact.length === 1) {
        let checksOtroValorV = JSON.parse(
          sessionStorage.getItem("facturaPagar")
        );
        if (typeof checksOtroValorV === "object") {
          if (checksOtroValor[checksOtroValorV[0]]) {
            infoFactura.push({
              titulo: "Otro valor",
              ayuda: "Otro valor a pagar",
              valor: `$ ${parseFloat(
                valuesOtroValor[parseInt(checksOtroValorV[0])]
              ).toLocaleString("en-US", {
                minimumFractionDigits: 2,
              })} ${fact[0]["moneda"]}`,
            });

            valorCheckout = parseFloat(
              valuesOtroValor[parseInt(checksOtroValorV[0])]
            );
            total = parseFloat(valuesOtroValor[parseInt(checksOtroValorV[0])]);
          }
        } else {
          if (checksOtroValor[checksOtroValorV]) {
            infoFactura.push({
              titulo: "Otro valor",
              ayuda: "Otro valor a pagar",
              valor: `$ ${parseFloat(
                valuesOtroValor[parseInt(checksOtroValorV)]
              ).toLocaleString("en-US", {
                minimumFractionDigits: 2,
              })} ${fact[0]["moneda"]}`,
            });

            valorCheckout = parseFloat(
              valuesOtroValor[parseInt(checksOtroValorV)]
            );
            total = parseFloat(valuesOtroValor[parseInt(checksOtroValorV)]);
          }
        }
      }
      //Validar si las opciones de recaudo tiene multiples valores para pago

      this.setState(
        {
          fechasValidacion: validarFecha,
          infoFactura,
          infoCabecera,
          infoEmpresa: info,
          total,
          moneda,
          iva,
          abonos,
          opcionPago,
          copiaOpcionPago: [...opcionPago],
          facturasCheckout: `id:${idCheckout}:valor:${valorCheckout}`,
          facturas: facturasCopy,
        },
        () => {
          let openAutomatic = JSON.parse(
            sessionStorage.getItem("autoCheckout")
          );
          if (openAutomatic) this.openCheckoutAutomatic();
        }
      );
    } else {
      this.props.openModal("Factura no encontrada.", "danger");
      this.props.history.push(ruta.home);
    }
  }
  openCheckoutAutomatic() {
    setTimeout(() => {
      this.openCheckout();
    }, 1000);
  }
  async handleScriptLoad() {
    let total = parseFloat(this.state.total);
    let subtotal = total - parseFloat(this.state.iva);
    const suscripcionProyecto = this.state.infoEmpresa.suscripcionProyecto;
    let data;
    try {
      data = await serviceApiGet(getGeoIpUrl());
    } catch (error) {
      reportPagoError(this, error, {
        service: "geo-ip",
        endpoint: getGeoIpUrl(),
      });
      return;
    }
    const ip = data.data ? data.data : null;

    let pathReintento = window.location.href.split("/").slice(0, -1).join("/");

    let dataCheckout = {
      name: `${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`,
      description: `${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`,
      currency: this.state.moneda,
      amount: total,
      checkout_version: checkoutVersion,
      tax_base: this.state.iva === 0 ? "0" : String(subtotal),
      tax: this.state.iva === 0 ? "0" : String(total - subtotal),
      country: "co",
      lang: "en",
      ipOrigen: ip,
      subscription: {
        suscriptionProjectId: suscripcionProyecto,
        parameterSearch: sessionStorage.getItem("parameterSearch")
          ? sessionStorage.getItem("parameterSearch")
          : null,
        isAdmin:
          this.state.isSuscrito && this.state.isSuscrito.id ? true : false,
        suscripcionId:
          this.state.isSuscrito && this.state.isSuscrito.id
            ? this.state.isSuscrito.id
            : null,
        accion:
          this.state.isSuscrito && this.state.isSuscrito.id
            ? "administrar"
            : "suscribir",
        facturas: JSON.parse(sessionStorage.getItem("facturas")),
        transaccionExtra10: this.state.facturasCheckout,
      },
    };
    sessionStorage.setItem("dataCheckout", JSON.stringify(dataCheckout));

    this.state.epayco.open({
      createOrder: () => {
        let total = parseFloat(this.state.total);
        let subtotal = total - parseFloat(this.state.iva);
        const suscripcionProyecto = this.state.infoEmpresa.suscripcionProyecto;
        return window.ePayco2.checkout.signature({
          data: {
            name: `${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`,
            description: `${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`,
            currency: this.state.moneda,
            amount: total,
            tax_base: this.state.iva === 0 ? "0" : String(subtotal),
            checkout_version: checkoutVersion,
            tax: this.state.iva === 0 ? "0" : String(total - subtotal),
            country: "co",
            lang: "en",
            ipOrigen: ip,
            pathReintento,
            subscription: {
              suscriptionProjectId: suscripcionProyecto,
              parameterSearch: sessionStorage.getItem("parameterSearch")
                ? sessionStorage.getItem("parameterSearch")
                : null,
              isAdmin:
                this.state.isSuscrito && this.state.isSuscrito.id
                  ? true
                  : false,
              suscripcionId:
                this.state.isSuscrito && this.state.isSuscrito.id
                  ? this.state.isSuscrito.id
                  : null,
              accion:
                this.state.isSuscrito && this.state.isSuscrito.id
                  ? "administrar"
                  : "suscribir",
              facturas: JSON.parse(sessionStorage.getItem("facturas")),
              transaccionExtra10: this.state.facturasCheckout,
            },
          },
        });
      },
      onChangeState: ({ button }) => {
        const { element, isSubscription } = button;
        if (isSubscription) element.textContent = "Administrar suscripción";
      },
      onCloseModal: () => {
        this.setState({ loadingSuscripciones: false });
      },
      onFinish: (data) => {
        if (data.data) {
          sessionStorage.setItem("responseSubscription", JSON.stringify(data));
          const isDelete = data.data.type == "isDelete";
          const isUpdate = data.data.type == "isUpdate";
          if(isDelete || isUpdate) {
            if (!toast.isActive("subscription-toast")) {
              toast.success("Administración finalizada exitosamente", {
                toastId: "subscription-toast",
                autoClose: 5000,
              });
            }
            this.props.history.push(`${ruta.home}`);
            return;
          }
          this.props.history.push(`${ruta.respuestaSuscripcion}`);
        }
      },
      selector: "#open-checkout",
    });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (Object.keys(nextProps).length > 0 && nextProps.info) {
      this.setState({
        infoEmpresa: nextProps.info,
      });
    }
  }
  homePath(tieneFacturas) {
    const ruta = JSON.parse(sessionStorage.getItem("rutas"));
    if (!tieneFacturas) {
      sessionStorage.removeItem("reservarConfig");
      sessionStorage.removeItem("facturas");
    }
    this.props.history.push(tieneFacturas ? ruta.facturas : ruta.home);
    this.setState({
      modal: {
        open: false,
      },
    });
  }
  borrarFacturasConPago(pagos) {
    let facturas = JSON.parse(sessionStorage.getItem("facturas"));
    pagos.forEach((pago) => {
      facturas = facturas.filter((factura) => pago.id != factura.id);
    });
    sessionStorage.setItem("facturas", JSON.stringify(facturas));
    return facturas.length > 0;
  }
  modalFacturasConPago(
    pagos,
    countPagas,
    countFacturasSeleccionadas,
    countTotalFacturas
  ) {
    let modalState = {
      typo: "warning",
      message: "",
      open: true,
      action: () => this.homePath(),
    };
    if (countFacturasSeleccionadas == 1) {
      if (countTotalFacturas == 1) {
        //caso 1
        modalState.message =
          "La factura que consultas está al día en pagos, el último pago Registrado fue el " +
          pagos[0].fecha;
      } else {
        //caso 2
        modalState.message = "La factura que consultas está al día en pagos.";
        let tieneFacturas = this.borrarFacturasConPago(pagos);
        modalState.action = () => this.homePath(tieneFacturas);
      }
    } else {
      //caso 3 y 4
      modalState.message = "Las facturas que consultas están al día en pagos.";
      if (countFacturasSeleccionadas != countPagas) {
        let tieneFacturas = this.borrarFacturasConPago(pagos);
        modalState.action = () => this.homePath(tieneFacturas);
      }
    }
    this.setState({ modal: modalState });
  }

  validateFactura() {
    this.setState({ loading: true });
    let facturas = JSON.parse(sessionStorage.getItem("facturas"));
    let facturasKeys = sessionStorage.getItem("facturaPagar")
      ? JSON.parse(sessionStorage.getItem("facturaPagar"))
      : [0];
    if (!Array.isArray(facturasKeys)) {
      facturasKeys = [facturasKeys];
    }

    const facturasId = facturasKeys.map((el) => facturas[el].id);
    return new Promise((resolve, reject) => {
      serviceApiResponse(
        {
          facturas: facturasId,
        },
        api.validarPago,
        "POST"
      )
        .then((response) => {
          if (response.success) {
            if (response.data.length > 0) {
              this.setState({ loading: false });
              this.modalFacturasConPago(
                response.data,
                response.data.length,
                facturasId.length,
                facturas.length
              );
              this.setState({ loading: false });
              resolve(false);
            } else {
              resolve(true);
            }
          } else {
            this.setState({ loading: false });
            reportPagoError(this, new Error("validar_pago_failed"), {
              endpoint: api.validarPago,
              backendMessage: response.text_response,
            });
            resolve(false);
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          reportPagoError(this, error, { endpoint: api.validarPago });
          reject(error);
        });
    });
  }
  
  async openCheckout() {
    try {
      const isValid = await this.validateFactura();
      if (!isValid) {
        return;
      }
    } catch (error) {
      return;
    }

    let abonosToSave = Object.assign([], this.state.abonos);
    if(this.state.otroValorChecked && this.state.otroValor > 0){
        abonosToSave[0] = this.state.otroValor;
    } else {
        abonosToSave[0] = this.state.total;
    }
    
    sessionStorage.setItem("abonos_factura", JSON.stringify(abonosToSave));
    sessionStorage.setItem("opcionPago_factura", JSON.stringify(this.state.opcionPago));
    
    let confirmUrl = `${REACT_APP_API_URL}${api.actualizarFacturaConfirmacion}`;
    let responseUrl = `${window.location.protocol}//${window.location.hostname}${ruta.respuesta}`;
    if (REACT_APP_SERVER_RESPONSE === "true") {
      responseUrl = `${REACT_APP_SERVER}${ruta.respuesta}`;
    }

    let factura = this.state.facturasCheckout;

    let total = parseFloat(this.state.total);

    let subtotal = total - parseFloat(this.state.iva);

    if (total < 1) {
      toast.warn(
        "No supera el valor mínimo ($0) permitido a pagar de la factura"
      );
      this.setState({ loading: false });
      return "";
    }
    let descripcion = this.state.infoFactura.find(
      (val) => val.entidad == "descripcion"
    );

    const OPCIONES_PAGO = {
      ABONO: "abono",
      PAGO_TOTAL: "total",
    }
    let InvoiceId = getInvoiceId(factura);
    let formatInvoiceId = InvoiceId;
    if(this.state.opcionPago.length === 1 && this.state.opcionPago[0] === OPCIONES_PAGO.ABONO) {
      const createRandomNumbers = String(Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000);
      formatInvoiceId = `${InvoiceId}-${createRandomNumbers}`;
    }  

    let data = {
      //Parametros compra (obligatorio)
      name: `${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`,
      description: descripcion
        ? descripcion.valor
        : `${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`,
      invoice: formatInvoiceId ?? '',
      currency: this.state.moneda,
      checkout_version: checkoutVersion,
      amount: total,
      tax_base: this.state.iva === 0 ? 0 : subtotal,
      tax: this.state.iva === 0 ? 0 : total - subtotal,
      country: "co",
      lang: "es",

      //Onpage="false" - Standard="true"
      external: "false",

      //Atributos opcionales
      // extra1: "extra1",
      // extra2: "extra2",
      // extra3: "extra3",
      extra10: factura,

      confirmation: confirmUrl,
      response: responseUrl,

      //Atributos cliente
      // name_billing: "Andres Perez",
      // address_billing: "Carrera 19 numero 14 91",
      // type_doc_billing: "cc",
      // mobilephone_billing: "3050000000",
      // number_doc_billing: "100000000"
    };

    let facturasSession = JSON.parse(sessionStorage.getItem("facturas"));
    if (
      this.state.opcionesRecaudo &&
      this.state.opcionesRecaudo.multiplesValoresPago &&
      this.state.opcionesRecaudo.multiplesValoresPago.activo &&
      facturasSession.length <= 1
    ) {
      let activo = this.state.infoFactura.filter((infoF) => {
        if (infoF.checked) {
          if (infoF.entidad === "total" && this.state.facturas[0]["iva"]) {
            let subtotal = total - this.state.facturas[0]["iva"];
            data.tax_base =
              this.state.facturas[0]["iva"] === 0 ? "0" : String(subtotal);
            data.tax =
              this.state.facturas[0]["iva"] === 0
                ? "0"
                : String(total - subtotal);
          }
          if (
            infoF.entidad === "segundoTotal" &&
            this.state.facturas[0]["segundoIva"]
          ) {
            let subtotal = total - this.state.facturas[0]["segundoIva"];
            data.tax_base =
              this.state.facturas[0]["segundoIva"] === 0
                ? "0"
                : String(subtotal);
            data.tax =
              this.state.facturas[0]["segundoIva"] === 0
                ? "0"
                : String(total - subtotal);
          }
          if (
            infoF.entidad === "tercerTotal" &&
            this.state.facturas[0]["tercerIva"]
          ) {
            let subtotal = total - this.state.facturas[0]["tercerIva"];
            data.tax_base =
              this.state.facturas[0]["tercerIva"] === 0
                ? "0"
                : String(subtotal);
            data.tax =
              this.state.facturas[0]["tercerIva"] === 0
                ? "0"
                : String(total - subtotal);
          }
        }
        return infoF.checked;
      });
      if (
        (activo && activo.length > 0) ||
        (this.state.opcionPago && this.state.opcionPago.length > 0
          ? this.state.opcionPago[0]
          : "") === "abono"
      ) {
        this.checkout(data);
      } else {
        toast.warn(
          "Debe seleccionar por lo menos un valor para realizar el pago"
        );
        this.setState({ loading: false });
      }
    } else {
      let fechasValidacion = this.state.fechasValidacion;
      let facturas = this.state.facturas;
      let vencidas = true;

      if (
        this.state.opcionesRecaudo != "" &&
        (this.state.opcionesRecaudo.fechasVencimiento.vencidas === undefined ||
          this.state.opcionesRecaudo.fechasVencimiento.vencidas === false)
      )
        vencidas = false;

      if (fechasValidacion.length > 0 && !vencidas) {
        if (fechasValidacion.length === 1) {
          let convertirFecha = facturas[0][fechasValidacion[0]].split("/");
          if (convertirFecha && convertirFecha.length <= 1) {
            convertirFecha = facturas[0][fechasValidacion[0]].split("-");
          }
          let dividirAnoDia = convertirFecha[2].split(" ");
          let convertirHora = dividirAnoDia[1].split(":");
          let now = new Date();
          let expiracionFactura = new Date(
            dividirAnoDia[0],
            parseInt(convertirFecha[1]),
            convertirFecha[0],
            convertirHora[0],
            convertirHora[1],
            convertirHora[2]
          );

          if (expiracionFactura.getTime() > now.getTime()) {
            toast.warn(
              "La factura que intenta consultar acaba de vencer, por favor intente consultar nuevamente."
            );
            this.setState({ loading: false });
          } else {
            this.checkout(data);
          }
        } else {
          let vencida = false;
          facturas.forEach((fact, k) => {
            let convertirFecha = fact[fechasValidacion[k]].split("/");
            if (convertirFecha && convertirFecha.length < 2) {
              convertirFecha = fact[fechasValidacion[k]].split("-");
            }

            let dividirAnoDia = convertirFecha[2].split(" ");
            let convertirHora = dividirAnoDia[1].split(":");

            let now = new Date();
            let expiracionFactura = new Date(
              convertirFecha[0],
              parseInt(convertirFecha[1]),
              dividirAnoDia[0],
              convertirHora[0],
              convertirHora[1],
              convertirHora[2]
            );

            if (expiracionFactura.getTime() < now.getTime()) {
              vencida = true;
              toast.warn(
                "Algunas de las facturas que intenta consultar acaban de vencer, por favor intente consultar nuevamente."
              );
            }
          });

          if (!vencida) {
            this.checkout(data);
          } else {
            this.setState({ loading: false });
          }
        }
      } else {
        this.checkout(data);
      }
    }
  }

  async checkout(data) {
    if (this.state.cambioValor) {
      if (
        this.state.pagoMinimo > data.amount &&
        this.state.opcionesRecaudo.modificarValorPagar.activo &&
        this.state.opcionesRecaudo.modificarValorPagar.opcion === ">"
      ) {
        toast.warn(
          `No supera el valor mínimo (${this.state.pagoMinimoMoneda}) permitido a pagar de la factura`
        );
        this.setState({
          loading: false,
        });
      } else if (
        this.state.pagoMinimo < data.amount &&
        this.state.opcionesRecaudo.modificarValorPagar.activo &&
        this.state.opcionesRecaudo.modificarValorPagar.opcion === "<"
      ) {
        toast.warn(
          `Supera el valor máximo (${this.state.pagoMinimoMoneda}) permitido a pagar de la factura`
        );
        this.setState({
          loading: false,
        });
      } else if (data.amount === 0) {
        toast.warn(
          "No supera el valor mínimo ($0) permitido a pagar de la factura"
        );
        this.setState({
          loading: false,
        });
      } else {
        // Se valida la version del checkout para abonos
        if (checkoutVersion === CHECKOUT_VERSION.V1) {
          let handler = window.ePayco.checkout.configure({
            key: parseJwt(),
            test: sessionStorage.getItem("test"),
          });
          if (typeof handler.onCloseModal === "function") {
            handler.onCloseModal(() => {
              this.setState({ loading: false });
            });
          } else {
            handler.onClosed(() => {
              this.setState({ loading: false });
            });
          }
          handler.open(data);
          this.setState({
            loading: false,
          });
        } else {
          let dataIp;
          try {
            dataIp = await serviceApiGet(getGeoIpUrl());
          } catch (error) {
            reportPagoError(this, error, {
              service: "geo-ip",
              endpoint: getGeoIpUrl(),
            });
            return;
          }
          const ip = dataIp.data;
          serviceApiResponse({
              ...data,
              ip,
              test: sessionStorage.getItem('test'),
          },api.sessionId, "POST" ).then((response) => {
              if (response.success) {
                  const sessionId = response.data.sessionId;
                  this.setState({
                      loading: false,
                  })
                  const handler = window.ePayco.checkout.configure({
                      sessionId,
                      external: false,
                      type: checkoutType.ONPAGE,
                      test: sessionStorage.getItem('test'),
                  })
                  handler.open();
              }
              else {
                reportPagoError(this, new Error("session_id_failed"), {
                  endpoint: api.sessionId,
                  backendMessage: response.text_response,
                });
              }
            })
          .catch((error) => {
              reportPagoError(this, error, { endpoint: api.sessionId });
          });
        } 
      }
    } else {

      if (checkoutVersion === CHECKOUT_VERSION.V1) {
          let handler = window.ePayco.checkout.configure({
            key: parseJwt(),
            test: sessionStorage.getItem("test"),
          });
    
          if (typeof handler.onCloseModal === "function") {
            handler.onCloseModal(() => {
              this.setState({ loading: false });
            });
          } else {
            handler.onClosed(() => {
              this.setState({ loading: false });
            });
          }
    
          handler.open(data);
    
          this.setState({
            loading: false,
          });
      } else {
        let dataIp;
        try {
          dataIp = await serviceApiGet(getGeoIpUrl());
        } catch (error) {
          reportPagoError(this, error, {
            service: "geo-ip",
            endpoint: getGeoIpUrl(),
          });
          return;
        }
          const ip = dataIp.data;
          serviceApiResponse({
              ...data,
              ip,
              test: sessionStorage.getItem('test'),
          },api.sessionId, "POST" ).then((response) => {
              if (response.success) {
                  const sessionId = response.data.sessionId;
                  this.setState({
                      loading: false,
                  })
                  const handler = window.ePayco.checkout.configure({
                      sessionId,
                      external: false,
                      type: checkoutType.ONPAGE,
                      test: sessionStorage.getItem('test'),
                  })
                  handler.open();
            } else {
              reportPagoError(this, new Error("session_id_failed"), {
                endpoint: api.sessionId,
                backendMessage: response.text_response,
              });
            }
          })
          .catch((error) => {
            reportPagoError(this, error, { endpoint: api.sessionId });
          });
              }                  
      
    }
  }

  downloadPdf() {
    sessionStorage.getItem("param");

    let abonos = Object.assign(this.state.abonos);
    if(this.state.otroValorChecked && this.state.otroValor > 0){
      abonos[0] = this.state.otroValor;
    } else {
      abonos[0] = this.state.total;
    }

    const data = {
      param: JSON.parse(sessionStorage.getItem("param")),
      informacion: JSON.parse(sessionStorage.getItem("informacion")),
      busqueda: JSON.parse(sessionStorage.getItem("configCampos")),
      facturas: JSON.parse(sessionStorage.getItem("facturas")),
      abonos: abonos,
      opcionPago: this.state.opcionPago,
      fechaFactura: JSON.parse(sessionStorage.getItem("fechaActualizacion")),
      total: sessionStorage.getItem("total"),
      facturaPagar: sessionStorage.getItem("facturaPagar")
        ? JSON.parse(sessionStorage.getItem("facturaPagar"))
        : [0],
    };

    this.setState({ loadingDownload: true });
    serviceApiResponse(data, api.exportar, "POST")
      .then((response) => {
        if (response.success) {
          const contentType = response.data.contentType;
          const b64Data = response.data.ruta;

          const blob = b64toBlob(b64Data, contentType);
          const blobUrl = URL.createObjectURL(blob);

          let element = document.getElementById("pdf");
          element.setAttribute("href", blobUrl);
          element.setAttribute("download", response.data.nombre);
          element.click();
        }
        this.setState({ loadingDownload: false });
      })
      .catch((error) => {
        reportPagoError(this, error, {
          endpoint: api.exportar,
          stateUpdates: { loadingDownload: false },
        });
      });
  }

 handleChangeRadio(e) {
    let value = e.target.value;
    let entidad = e.target.name;
    let abonos = [];
    let opcionPago = [];
    let infoFactura = this.state.infoFactura;
    let extra10 = this.state.facturasCheckout.split("valor")[0];
    let newInfo = infoFactura.map((item, key) => {
      if (
        item.entidad === "total" ||
        item.entidad === "segundoTotal" ||
        item.entidad === "tercerTotal"
      ) {
        if (item.entidad === entidad) {
          opcionPago.push(entidad);
          abonos.push(null);
          item.checked = true;
          this.setState({
            otroValorChecked: false,
            otroValor: 0,
          });
        } else {
          item.checked = false;
        }
      }
      return item;
    });
    if (entidad === "otro") {
      opcionPago.push("abono");
      abonos.push(value);
      const isChecked = !this.state.otroValorChecked;
      this.setState({
        otroValorChecked: isChecked,
        cambioValor: true,
        ...(!isChecked ? { otroValor: 0 } : {}),
      });
    }
    extra10 += `valor:${value}`;
    this.setState({
      infoFactura: newInfo,
      facturasCheckout: extra10,
      total: value,
      opcionPago,
      abonos,
    });
  }

  handleClickRadioOtro(e) {
    if (this.state.otroValorChecked) {
      e.preventDefault();
      
      let defaultOpcion = "total";
      if (this.state.copiaOpcionPago && this.state.copiaOpcionPago.length > 0) {
        defaultOpcion = this.state.copiaOpcionPago[0];
      }

      let infoFactura = this.state.infoFactura;
      let totalItem = infoFactura.find((item) => item.entidad === defaultOpcion);
      if (!totalItem) {
        totalItem = infoFactura.find((item) =>
          item.entidad === "total" ||
          item.entidad === "segundoTotal" ||
          item.entidad === "tercerTotal"
        );
        if (totalItem) {
          defaultOpcion = totalItem.entidad;
        }
      }

      let newInfo = infoFactura.map((item) => {
        if (item.entidad === defaultOpcion) {
          item.checked = true;
        } else if (
          item.entidad === "total" ||
          item.entidad === "segundoTotal" ||
          item.entidad === "tercerTotal"
        ) {
          item.checked = false;
        }
        return item;
      });

      let defaultValue = 0;
      if (totalItem) {
        defaultValue = totalItem.valorReal || 0;
      }

      let extra10 = this.state.facturasCheckout.split("valor")[0];
      extra10 += `valor:${defaultValue}`;

      this.setState({
        otroValorChecked: false,
        otroValor: 0,
        infoFactura: newInfo,
        facturasCheckout: extra10,
        total: defaultValue,
        opcionPago: [defaultOpcion],
        abonos: [null],
      });
    }
  }

  changeOtroValor(value, name) {
    let extra10 = this.state.facturasCheckout.split("valor")[0];

    let configuracion = JSON.parse(sessionStorage.getItem("configuracion"));

    if (configuracion) {
      let busquedas = configuracion.busqueda;
      if (busquedas) {
        let search = busquedas.find((val) => !!val.decimal);
        if (search && value) {
          if (search.decimal != "") {
            value = Number(String(value).replace(/[^0-9.]+/g, ""));
          } else {
            value = Number(String(value).replace(/[^0-9]+/g, ""));
          }
        } else {
          value = Number(String(value).replace(/[^0-9]+/g, ""));
        }
      }
    }

    extra10 += `valor:${value}`;

    if (this.state.opcionesRecaudo.modificarValorPagar.opcion !== "!=") {
      let valores = [];
      let valoresMoneda = [];
      // let valorComparacionMaximo = 0;
      // let valorComparacionMinimo = 0;

      this.state.infoFactura.filter((infoFac, key) => {
        if (
          infoFac.entidad === "total" ||
          infoFac.entidad === "segundoTotal" ||
          infoFac.entidad === "tercerTotal"
        ) {
          valores.push(infoFac.valorReal);
          valoresMoneda.push(infoFac.valor);
        }
        // if (infoFac.entidad === "total") {
        // valorComparacionMinimo = infoFac.valorReal;
        // }
      });

      let valorMaximo = valores[0];
      let valorMaximoMoneda = valoresMoneda[0];
      let valorMinimo = valores[0];

      for (let i = 1; i < valores.length; i++) {
        if (valores[i]) {
          if (valorMaximo < valores[i]) {
            valorMaximo = valores[i];
          }

          if (valorMinimo > valores[i]) {
            valorMinimo = valores[i];
          }
        }
      }
      if (
        this.state.opcionesRecaudo.modificarValorPagar.opcion === "<" &&
        value > valorMaximo
      ) {
        toast.warn(
          `Supera el valor máximo (${valorMaximoMoneda}) permitido a pagar de la factura`, {
            toastId: "maximo-toast",
          }
        );
        this.setState({
          valorInvalido: true,
          total: this.state.total,
          otroValor: this.state.otroValor,
          facturasCheckout: this.state.facturasCheckout,
        });
      } else if (
        this.state.opcionesRecaudo.modificarValorPagar.opcion === ">" &&
        value < valorMaximo
      ) {
        toast.warn(
          `No supera el valor mínimo (${valorMaximoMoneda}) permitido a pagar de la factura`, {
            toastId: "minimo-toast",
          }
        );
        this.setState({
          valorInvalido: true,
          total: this.state.total,
          otroValor: this.state.otroValor,
          facturasCheckout: this.state.facturasCheckout,
        });
      } else {
        this.setState({
          valorInvalido: false,
          total: parseFloat(value),
          otroValor: parseFloat(value),
          facturasCheckout: extra10,
          cambioValor: true,
          pagoMinimo: valorMaximo,
          pagoMinimoMoneda: valorMaximoMoneda,
        });
      }
    } else {
      this.setState({
        total: parseFloat(value),
        otroValor: parseFloat(value),
        facturasCheckout: extra10,
      });
    }
  }
  FormatoCampo(Inf) {
    let valor = "";
    switch (Inf.tipo_campo_2) {
      case "moneda":
        valor = `$ ${parseFloat(Inf.valor).toLocaleString("en-US", {
          minimumFractionDigits: 0,
        })} ${Inf.moneda}`;
        break;
      case "numerico":
        valor = parseFloat(Inf.valor).toLocaleString("en-US", {
          minimumFractionDigits: 0,
        });
        break;
      case "porcentaje":
        valor = `${parseFloat(Inf.valor).toLocaleString("en-US", {
          minimumFractionDigits: 0,
        })} %`;
        break;
      default:
        valor = Inf.valor;
        break;
    }
    return valor;
  }

  render() {
    let facturas = JSON.parse(sessionStorage.getItem("facturas"));
    let opcionesRecaudo =
      JSON.parse(sessionStorage.getItem("opcionesRecaudo")) ||
      this.state.opcionesRecaudo;
    if (
      opcionesRecaudo !== "" &&
      opcionesRecaudo &&
      opcionesRecaudo.multiplesValoresPago.activo &&
      facturas.length === 1
    ) {
      return (
        <Elastic
          felx={"1 0 auto"}
          className={"wc cambio "}
          css={css`
            animation: ${Transition} 1s cubic-bezier(0.075, 0.82, 0.165, 1) 1;
          `}
        >
          <Modal
            open={this.state.modal.open}
            close={() => this.closeModal()}
            message={this.state.modal.message}
            tipo={this.state.modal.typo}
            closeBtn={false}
            actions={[
              {
                text: "Volver",
                onClicK: () => null,
                tipo: "white",
              },
            ]}
          />
          <Mycard
            title={`Pagos Online`}
            back={
              facturas && facturas.length > 1
                ? sessionStorage.getItem("facturaPagar")
                  ? ruta.facturas
                  : ruta.home
                : ruta.home
            }
            className={" col-12 col-lg-10 col-xl-7 mx-auto px-0 "}
            footer={
              this.state.infoEmpresa.mostrarDatos == 1 && (
                <FooterFactura info={this.state.infoEmpresa} />
              )
            }
            history={this.props.history}
            visible
            disabled={this.state.loading || this.state.loadingDownload}
          >
            <div className="wc">
              <div className="col-12 pb-3">
                <Flex jc={"space-between"} className={"py-1 px-3"}>
                  <b className={"cg"}>Descripción</b>
                  <Line dotted className={"wc"} />
                </Flex>

                {this.state.infoFactura.map((inf, key) => {
                  return inf.entidad === "total" ||
                    inf.entidad === "segundoTotal" ||
                    inf.entidad === "tercerTotal" ? (
                    <div>
                      <Flex
                        jc={"space-between"}
                        className={"py-1 px-3"}
                        key={`inf-${key}`}
                      >
                        <Tooltip
                          id={`help-${key}`}
                          place="top"
                          title={inf.ayuda}
                          trigger={"mouseenter"}
                          disabled={!inf.ayuda}
                        >
                          <small data-tip data-for={`help-${key}`}>
                            {inf.entidad !== "facturaId" && (
                              <MyRadio
                                color="primary"
                                value={inf.valorReal}
                                checked={inf.checked}
                                name={inf.entidad}
                                onChange={this.handleChangeRadio.bind(this)}
                                disabled={
                                  this.state.loading ||
                                  this.state.loadingDownload
                                }
                              />
                            )}
                            <b>{inf.titulo}</b>
                          </small>
                        </Tooltip>
                        <small className={"mb-0 cg"}>{inf.valor}</small>
                        <Line dotted className={"wc"} />
                      </Flex>
                      {key === this.state.infoFactura.length - 1 &&
                        opcionesRecaudo &&
                        opcionesRecaudo.modificarValorPagar.activo && (
                          <Flex
                            jc={"space-between"}
                            className={"py-1 px-3"}
                            key={`inf-${key}`}
                          >
                            <Tooltip
                              id={`help-otro-${key}`}
                              place="top"
                              arrow={true}
                              trigger={"mouseenter"}
                              title={
                                opcionesRecaudo.modificarValorPagar.opcion ===
                                "<"
                                  ? "Editar el valor de la factura por un valor igual o inferior"
                                  : opcionesRecaudo.modificarValorPagar
                                      .opcion === ">"
                                  ? "Editar el valor de la factura por un valor igual o superior"
                                  : "Editar el valor a pagar de la factura"
                              }
                              disabled={
                                !opcionesRecaudo ||
                                !opcionesRecaudo.modificarValorPagar.activo
                              }
                            >
                              <small data-tip data-for={`help-otro-${key}`}>
                                <MyRadio
                                  color="primary"
                                  name={"otro"}
                                  onChange={this.handleChangeRadio.bind(this)}
                                  onClick={this.handleClickRadioOtro.bind(this)}
                                  checked={this.state.otroValorChecked}
                                  value={this.state.otroValor}
                                  disabled={
                                    this.state.loading ||
                                    this.state.loadingDownload
                                  }
                                />
                                <b>{"Otro valor"}</b>
                              </small>
                            </Tooltip>
                            <div className="max-width-150">
                              <MyCampo
                                type="mount"
                                placeholder={"Otro valor"}
                                value={this.state.otroValor}
                                name={"otroValor"}
                                onChangeValor={this.changeOtroValor.bind(this)}
                                obligatory={false}
                                disabled={
                                  !this.state.otroValorChecked ||
                                  this.state.loading ||
                                  this.state.loadingDownload
                                }
                              />
                            </div>
                          </Flex>
                        )}
                    </div>
                  ) : (
                    <div>
                      <Flex
                        jc={"space-between"}
                        className={"py-1 px-3"}
                        key={`inf-${key}`}
                      >
                        {inf.ayuda !== "" && (
                          <ReactTooltip
                            id={`help-${key}`}
                            place="right"
                            type="info"
                            effect="solid"
                          >
                            {inf.ayuda}
                          </ReactTooltip>
                        )}

                        <small data-tip data-for={`help-${key}`}>
                          <b>{inf.titulo}</b>
                        </small>
                        <small className={"mb-0 cg"}>{inf.valor}</small>
                        <Line dotted className={"wc"} />
                      </Flex>
                      {key === this.state.infoFactura.length - 1 &&
                        opcionesRecaudo &&
                        opcionesRecaudo.modificarValorPagar.activo && (
                          <Flex
                            jc={"space-between"}
                            className={"py-1 px-3"}
                            key={`inf-${key}`}
                          >
                            {opcionesRecaudo &&
                              opcionesRecaudo.modificarValorPagar.activo && (
                                <ReactTooltip
                                  id={`help-otro-${key}`}
                                  place="right"
                                  type="info"
                                  effect="solid"
                                >
                                  {opcionesRecaudo.modificarValorPagar
                                    .opcion === "<"
                                    ? "Editar el valor de la factura por un valor igual o inferior"
                                    : opcionesRecaudo.modificarValorPagar
                                        .opcion === ">"
                                    ? "Editar el valor de la factura por un valor igual o superior"
                                    : "Editar el valor a pagar de la factura"}
                                </ReactTooltip>
                              )}
                            <small data-tip data-for={`help-otro-${key}`}>
                              <MyRadio
                                color="primary"
                                name={"otro"}
                                onChange={this.handleChangeRadio.bind(this)}
                                onClick={this.handleClickRadioOtro.bind(this)}
                                checked={this.state.otroValorChecked}
                                value={
                                  this.state.otroValor ||
                                  this.state.loadingDownload ||
                                  this.state.loading
                                }
                              />
                              <b>{"Otro valor"}</b>
                            </small>
                            <div className="max-width-150">
                              <MyCampo
                                type="mount"
                                placeholder={"Otro valor"}
                                value={this.state.otroValor}
                                name={"otroValor"}
                                onChangeValor={this.changeOtroValor.bind(this)}
                                obligatory={false}
                                disabled={
                                  !this.state.otroValorChecked ||
                                  this.state.loading ||
                                  this.state.loadingDownload
                                }
                              />
                            </div>
                          </Flex>
                        )}
                    </div>
                  );
                })}
                <div
                  className="col-12 col-md-4 col-lg-4 mt-3 line-height-0"
                  onClick={() => this.downloadPdf()}
                >
                  <Btn
                    bg
                    hg={"35"}
                    loading={this.state.loadingDownload}
                    disabled={this.state.loading}
                  >
                    <img
                      src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/download.png")}
                      alt=""
                      className={"mr-2"}
                    />
                    DESCARGAR
                  </Btn>
                </div>
                <a hidden id="pdf">
                  {" "}
                </a>
              </div>
              <Line />
              <Flex className="col-12 px-lg-4 pt-3 ">
                <div className="col-12 pt-3  px-md-0">
                  <Btn
                    loading={this.state.loading}
                    disabled={this.state.loading || this.state.loadingDownload || this.state.valorInvalido}
                    onClick={() => this.openCheckout()}
                  >
                    {!this.state.loading && "Pagar"}
                  </Btn>
                </div>
              </Flex>
            </div>
          </Mycard>
        </Elastic>
      );
    } else if (
      opcionesRecaudo !== "" &&
      opcionesRecaudo &&
      opcionesRecaudo.modificarValorPagar &&
      opcionesRecaudo.modificarValorPagar.activo &&
      facturas.length === 1
    ) {
      return (
        <Elastic
          felx={"1 0 auto"}
          className={"wc cambio "}
          css={css`
            animation: ${Transition} 1s cubic-bezier(0.075, 0.82, 0.165, 1) 1;
          `}
        >
          <Modal
            open={this.state.modal.open}
            close={() => this.closeModal()}
            message={this.state.modal.message}
            tipo={this.state.modal.typo}
            closeBtn={false}
            actions={[
              {
                text: "Volver",
                onClicK: () => null,
                tipo: "white",
              },
            ]}
          />
          <Script
            url={checkoutScriptVersion}
            onLoad={() => {
                const epayco = window.ePayco2.init({
                  configure: {
                    key: parseJwt(),
                    test: true,
                  },
                });
                this.setState({ epayco });
            }}
          />
          <Mycard
            title={`${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`}
            back={
              facturas && facturas.length > 1
                ? sessionStorage.getItem("facturaPagar")
                  ? ruta.facturas
                  : ruta.home
                : ruta.home
            }
            className={" col-12 col-lg-10 col-xl-7 mx-auto px-0"}
            footer={
              this.state.infoEmpresa.mostrarDatos == 1 && (
                <FooterFactura info={this.state.infoEmpresa} />
              )
            }
            history={this.props.history}
            visible
          >
            <div className="wc">
              <div className="col-12 pb-3">
                <Flex jc={"space-between"} className={"py-1 px-3"}>
                  <b className={"cg"}>Descripción</b>
                  <Line dotted className={"wc"} />
                </Flex>

                {this.state.infoFactura.map((inf, key) => {
                  return this.state.infoFactura.length - 1 === key ? (
                    <div>
                      <Flex
                        jc={"space-between"}
                        className={"py-1 px-3"}
                        key={`inf-${key}`}
                      >
                        {inf.ayuda !== "" && (
                          <ReactTooltip
                            id={`help-${key}`}
                            place="right"
                            type="info"
                            effect="solid"
                          >
                            {inf.ayuda}
                          </ReactTooltip>
                        )}

                        <small data-tip data-for={`help-${key}`}>
                          <b>{inf.titulo}</b>
                        </small>
                        <small className={"mb-0 cg"}>{inf.valor}</small>
                        <Line dotted className={"wc"} />
                      </Flex>
                      <Flex
                        jc={"space-between"}
                        className={"py-1 px-3"}
                        key={`inf-${key}`}
                      >
                        {opcionesRecaudo &&
                          opcionesRecaudo.modificarValorPagar.activo && (
                            <ReactTooltip
                              id={`help-otro-${key}`}
                              place="right"
                              type="info"
                              effect="solid"
                            >
                              {opcionesRecaudo.modificarValorPagar.opcion ===
                              "<"
                                ? "Editar el valor de la factura por un valor igual o inferior"
                                : opcionesRecaudo.modificarValorPagar.opcion ===
                                  ">"
                                ? "Editar el valor de la factura por un valor igual o superior"
                                : "Editar el valor a pagar de la factura"}
                            </ReactTooltip>
                          )}
                        <small data-tip data-for={`help-otro-${key}`}>
                          <MyRadio
                            color="primary"
                            name={"otro"}
                            onChange={this.handleChangeRadio.bind(this)}
                            onClick={this.handleClickRadioOtro.bind(this)}
                            checked={this.state.otroValorChecked}
                            value={this.state.otroValor}
                          />
                          <b>{"Otro valor"}</b>
                        </small>
                        <div className="max-width-150">
                          <MyCampo
                            type="mount"
                            placeholder={"Otro valor"}
                            value={this.state.otroValor}
                            name={"otroValor"}
                            onChangeValor={this.changeOtroValor.bind(this)}
                            obligatory={false}
                            disabled={!this.state.otroValorChecked}
                          />
                        </div>
                      </Flex>
                    </div>
                  ) : (
                    <Flex
                      jc={"space-between"}
                      className={"py-1 px-3"}
                      key={`inf-${key}`}
                    >
                      {inf.ayuda !== "" && (
                        <ReactTooltip
                          id={`help-${key}`}
                          place="right"
                          type="info"
                          effect="solid"
                        >
                          {inf.ayuda}
                        </ReactTooltip>
                      )}

                      <small data-tip data-for={`help-${key}`}>
                        <b>{inf.titulo}</b>
                      </small>
                      <small className={"mb-0 cg"}>{inf.valor}</small>
                      <Line dotted className={"wc"} />
                    </Flex>
                  );
                })}
                <div
                  className="col-12 col-md-4 col-lg-4 mt-3 line-height-0"
                  onClick={() => this.downloadPdf()}
                >
                  <Btn
                    bg
                    hg={"35"}
                    disabled={this.state.loading}
                    loading={this.state.loadingDownload}
                  >
                    <img
                      src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/download.png")}
                      alt=""
                      className={"mr-2"}
                    />
                    DESCARGAR
                  </Btn>
                </div>
                <a hidden id="pdf">
                  {" "}
                </a>
              </div>
              <Line />
              <Flex alg={"flex-start"} className="col-12 px-lg-4 pt-3">
                <div
                  className={
                    this.state.infoEmpresa.suscripcionProyecto
                      ? "col-6 pt-3"
                      : "col-12 pt-3  px-md-0"
                  }
                >
                  <Btn
                    loading={this.state.loading}
                    disabled={
                      this.state.loading || this.state.loadingSuscripciones || this.state.valorInvalido
                    }
                    onClick={() => this.openCheckout()}
                  >
                    {this.state.loading ? "" : "Pagar"}
                  </Btn>
                </div>
                {this.state.infoEmpresa.suscripcionProyecto &&
                !this.state.isSuscrito ? (
                  <div className="col-6 pt-3">
                    <Btn
                      id="open-checkout"
                      loading={this.state.loadingSuscripciones}
                      disabled={this.state.loadingSuscripciones}
                      onClick={() => {
                        this.handleScriptLoad();
                        this.setState({ loadingSuscripciones: true });
                      }}
                    >
                      {!this.state.loadingSuscripciones && "Suscribir factura"}
                    </Btn>
                  </div>
                ) : this.state.isSuscrito ? (
                  <div className="col-6 pt-3">
                    <Btn
                      id="open-checkout"
                      loading={this.state.loadingSuscripcione}
                      disabled={this.state.loadingSuscripciones}
                      onClick={() => {
                        this.handleScriptLoad();
                        this.setState({ loadingSuscripciones: true });
                      }}
                    >
                      {!this.state.loadingSuscripciones &&
                        "Administrar suscripción"}
                    </Btn>
                  </div>
                ) : (
                  ""
                )}
              </Flex>
            </div>
          </Mycard>
        </Elastic>
      );
    } else {
      return (
        <Elastic
          felx={"1 0 auto"}
          className={"wc cambio"}
          css={css`
            animation: ${Transition} 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 1;
          `}
        >
          <Modal
            open={this.state.modal.open}
            close={() => null}
            message={this.state.modal.message}
            tipo={this.state.modal.typo}
            closeBtn={false}
            actions={[
              {
                text: "Volver",
                onClicK: () => this.state.modal.action(),
                tipo: "white",
              },
            ]}
          />
          <Script
            url={checkoutScriptVersion}
            onLoad={() => {
              const epayco = window.ePayco2.init({
                configure: {
                  key: parseJwt(),
                  test: true,
                },
              });
              this.setState({ epayco });
            }}
          />
          <Mycard
            title={`${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`}
            back={
              facturas &&
              facturas.length > 1 &&
              sessionStorage.getItem("facturaPagar")
                ? ruta.facturas
                : ruta.home
            }
            className={"col-12 col-lg-10 col-xl-7 mx-auto px-0 "}
            footer={
              this.state.infoEmpresa.mostrarDatos == 1 && (
                <FooterFactura info={this.state.infoEmpresa} />
              )
            }
            history={this.props.history}
            visible
          >
            <div className="wc">
              <div className="col-12 pb-3">
                <Flex jc={"space-between"} className={"py-1 px-3"}>
                  <b className={"cg"}>Descripción</b>
                  <Line dotted className={"wc"} />
                </Flex>
                {this.state.infoFactura.map((inf, key) => {
                  return String(inf.valor).includes("$ 0") &&
                    this.state.projectId ==
                      REACT_APP_PROJECT_ID_RECAUDO &&
                    !inf.titulo.includes("descuento") ? null : (
                    <Flex
                      jc={"space-between"}
                      className={"py-1 px-3"}
                      key={`inf-${key}`}
                    >
                      {inf.ayuda !== "" && (
                        <ReactTooltip
                          id={`help-${key}`}
                          place="right"
                          type="info"
                          effect="solid"
                        >
                          {inf.ayuda}
                        </ReactTooltip>
                      )}

                      <small data-tip data-for={`help-${key}`}>
                        <b>{inf.titulo}</b>
                      </small>
                      <small className={"mb-0 cg"}>
                        {this.FormatoCampo(inf)}
                      </small>
                      <Line dotted className={"wc"} />
                    </Flex>
                  );
                })}
                <div
                  className="col-12 col-md-4 col-lg-4 mt-3 line-height-0"
                  onClick={() => this.downloadPdf()}
                >
                  <Btn
                    bg
                    hg={"35"}
                    loading={this.state.loadingDownload}
                    disabled={
                      this.state.loading || this.state.loadingSuscripciones
                    }
                  >
                    {!this.state.loadingDownload && (
                      <Fragment>
                        <img
                          src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/download.png")}
                          alt=""
                          className={"mr-2"}
                        />
                        DESCARGAR
                      </Fragment>
                    )}
                  </Btn>
                </div>
                <a hidden id="pdf">
                  {" "}
                </a>
              </div>
              <Line />
              <Flex
                alg={"flex-start"}
                className="col-12 px-lg-4 fixed-to-bottom"
              >
                <div
                  className={
                    this.state.infoEmpresa.suscripcionProyecto
                      ? "col-col-12 col-md-6 pt-3"
                      : "col-12 pt-3  px-md-0"
                  }
                >
                  <Btn
                    loading={this.state.loading}
                    disabled={
                      this.state.loadingSuscripciones ||
                      this.state.loadingDownload ||
                      this.state.valorInvalido
                    }
                    onClick={() => {
                      this.openCheckout();
                    }}
                  >
                    Pagar
                  </Btn>
                </div>
                <div className="col-col-12 col-md-6 pt-3">
                  {this.state.infoEmpresa.suscripcionProyecto &&
                    !this.state.isSuscrito && (
                      <Btn
                        id="open-checkout"
                        loading={this.state.loadingSuscripciones}
                        disabled={
                          this.state.loadingSuscripciones ||
                          this.state.loading ||
                          this.state.loadingDownload
                        }
                        onClick={() => {
                          this.handleScriptLoad();
                          this.setState({ loadingSuscripciones: true });
                        }}
                      >
                        Suscribir factura
                      </Btn>
                    )}
                  {this.state.isSuscrito && (
                    <Btn
                      id="open-checkout"
                      loading={this.state.loadingSuscripciones}
                      disabled={
                        this.state.loadingSuscripciones ||
                        this.state.loading ||
                        this.state.loadingDownload
                      }
                      onClick={() => {
                        this.handleScriptLoad();
                        this.setState({ loadingSuscripciones: true });
                      }}
                    >
                      {!this.state.loadingSuscripciones &&
                        "Administrar suscripción"}
                    </Btn>
                  )}
                </div>
              </Flex>
            </div>
          </Mycard>
        </Elastic>
      );
    }
  }
}

export default withRouter(FacturaPagar);
